<template lang="pug">
v-modal.custom-modal(:visible="isTipShow",
  :closable="false",
  :mask-closable="false",
  :destroy-after-close="true",
  :center="true"
  title='服务协议'
)
  div.message 
    p.tip 为确保您已知晓360分析及您相关权益条款，还请阅读
      a.link(href="https://s4.ssl.qhres.com/static/68681a638322a648.pdf", target="_blank") 360服务协议
      | 并点击 “确认” 表明同意该服务协议
    button.btn.btn-primary.btn-small.btn-mgr(
      @click="closeModal()",
      type="button"
    ) 确认
</template>
<script>
export default {
  data() {
    return {
      isTipShow: true
    }
  },
  methods: {
    closeModal() {
      const changeStatusPromise = this.$http.get('/api/user/privacyStatusChange', {
        params: {
          status: 1
        }
      })
      this.$store.dispatch('VUE_HTTP', [changeStatusPromise])
        .then(res => {
          if (!res.errno) {
            this.isTipShow = false
            location.href = '/login/doAuth'
          } else {
            this.$Modal.warn('状态修改失败，请重新登录后重试～')
            setTimeout(() => {
              location.href = '/login/exit'              
            }, 2000);
          }
        })
      
    }
  },
}
</script>
<style>
.custom-modal .close {
  display: none;
}
.custom-modal .message {
  width: 447px;
  margin: 30px;
  font-size: 14px;
  text-align: center;
}
.custom-modal .tip {
  margin-bottom: 30px;
  text-align: left;
}
.custom-modal .link {
  color: #56BF8B;
  margin: 0 5px;
}
</style>


// WEBPACK FOOTER //
// privacyModal.vue?f758ca0c